@if (model && model.organizationId) {
    @if (isLoading) {
        <div class="fancy-loader"></div>
    } @else {
        <kri-linkable
            #linkable
            displayValueProp="name"
            [(linked)]="linked"
            [(unlinked)]="unlinked"
            [hideActions]="true"
            [orderByValueProperty]="true"
            [disabled]="!permissions.canLinkKri"
            (linkedChange)="linkedChanged($event)"
            (onReloadClicked)="reloadClicked()"
        >
        </kri-linkable>
    }
} @else {
    <div>{{ 'risk.selectOrgFirst' | transloco }}</div>
}
